import { Loader } from 'components/Loader/Loader';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import SessionExpiredDialog from 'components/SessionExpiredDialog/SessionExpiredDialog';
import { useAuthContext } from 'utils/contexts/AuthContext';
import { AuthState } from 'utils/contexts/AuthContext/AuthContextType';

export const PrivateRoute = () => {
    const { pathname: path } = useLocation();
    const { account, authState, goToLogin } = useAuthContext();

    const isAuthenticated = authState === AuthState.AUTHENTICATED;
    const isUnauthenticated = authState === AuthState.UNAUTHENTICATED;
    const hasSessionExpired = isUnauthenticated && !!account;

    useEffect(() => {
        if (isUnauthenticated && !hasSessionExpired) {
            goToLogin(path);
        }
    }, [isUnauthenticated, hasSessionExpired, path, goToLogin]);

    return isAuthenticated || hasSessionExpired ? (
        <>
            <Outlet />
            <SessionExpiredDialog visible={hasSessionExpired} />
        </>
    ) : (
        <Loader />
    );
};
